import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { Card } from "@mantine/core";
import { Form } from "react-bootstrap";
import { Button } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../config";

export default function FlashcardEditor() {
  const [flashcard, setFlashcard] = useState({ front: "", back: "" });
  const [flashcards, setFlashcards] = useState([]);
  const [front, setFront] = useState("");
  const [back, setBack] = useState("");

  const { id, cardId } = useParams();
  const userId = localStorage.getItem("userId");
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(`${API_URL}/set/${userId}/${id}`)
      .then((response) => {})
      .catch((error) => console.error(error));
  }, [id]);

  useEffect(() => {
    for (let i = 0; i < flashcards.length; i++) {
      if (flashcards[i]._id === cardId) {
        setFlashcard(flashcards[i]);
        setFront(flashcards[i].front);
        setBack(flashcards[i].back);
      }
    }
  }, [flashcards, cardId]);

  function handleSave() {
    axios
      .put(`${API_URL}/set/${id}/${cardId}`, {
        front: front,
        back: back,
      })
      .then(() => {
        navigate(`/cards/${id}/edit`);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  return (
    <div>
      <Card
        shadow="md"
        style={{
          position: "absolute",
          left: "37%",
          top: "20%",
          width: "30%",
          maxWidth: "500px",
          margin: "auto auto",
          height: "320px",
        }}
      >
        <Form>
          <Form.Group>
            <Form.Label>Front</Form.Label>
            <Form.Control
              name="front"
              value={front}
              onChange={(e) => setFront(e.target.value)}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Back</Form.Label>
            <Form.Control
              name="back"
              value={back}
              onChange={(e) => setBack(e.target.value)}
            />
          </Form.Group>
          <Button
            className="w-100"
            size="lg"
            variant="light"
            color="red"
            style={{
              marginTop: "20px",
              borderRadius: "10px",
              borderColor: "red",
            }}
            onClick={() => navigate(`/cards/${id}/edit`)}
          >
            Cancel
          </Button>
          <Button
            className="w-100"
            size="lg"
            variant="light"
            style={{
              marginTop: "20px",
              borderRadius: "10px",
              borderColor: "blue",
            }}
            onClick={handleSave}
          >
            Save
          </Button>
        </Form>
      </Card>
    </div>
  );
}
